module.exports = __webpack_public_path__ + "img/menu03.a94f0f7d.jpg";